import { cloneElement, type ReactElement } from 'react';

// MUI
import Box from '@mui/material/Box';

const UtilsIcon = ({
  label,
  icon,
  hoverIcon,
  hoverStrokeColor,
  onClick,
}: {
  label: string;
  icon: ReactElement;
  hoverIcon?: ReactElement;
  hoverStrokeColor?: string;
  onClick: () => void;
}) => {
  const transitionDuration = `0.5s`;

  return (
    <Box
      onClick={onClick}
      sx={{
        maxWidth: '40px',
        height: '40px',
        backgroundColor: 'white',
        borderRadius: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        cursor: 'pointer',
        boxShadow: '5px 5px 5px #DFDFDF',
        transition: `max-width ${transitionDuration} ease-in-out, padding ${transitionDuration} ease-in-out, background-color ${transitionDuration} ease-in-out`,
        overflow: 'hidden',
        pl: 1,
        pr: 0,
        position: 'relative',
        '&:hover': {
          maxWidth: '300px',
          backgroundColor: '#FFF9E6',
          pr: 2,
          ...(hoverStrokeColor && {
            '& svg': {
              stroke: hoverStrokeColor,
            },
          }),
          ...(hoverIcon && {
            '& .default-icon': {
              opacity: 0,
            },
            '& .hover-icon': {
              opacity: 1,
            },
          }),
        },
      }}
    >
      <Box
        sx={{
          minWidth: '24px',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          '& svg': {
            stroke: 'black',
            strokeWidth: '1',
            transition: `stroke ${transitionDuration} ease-in-out, opacity ${transitionDuration} ease-in-out`,
          },
        }}
      >
        <Box
          className="default-icon"
          sx={{
            display: 'flex',
            alignItems: 'center',
            opacity: 1,
            transition: `opacity ${transitionDuration} ease-in-out`,
          }}
        >
          {cloneElement(icon, { width: '24px', height: '24px' })}
        </Box>
        {hoverIcon && (
          <Box
            className="hover-icon"
            sx={{
              display: 'flex',
              alignItems: 'center',
              position: 'absolute',
              opacity: 0,
              transition: `opacity ${transitionDuration} ease-in-out`,
            }}
          >
            {cloneElement(hoverIcon, { width: '24px', height: '24px' })}
          </Box>
        )}
      </Box>
      <Box
        sx={{
          whiteSpace: 'nowrap',
          ml: 1,
          fontSize: '14px',
          fontWeight: '500',
          color: '#333',
        }}
      >
        {label}
      </Box>
    </Box>
  );
};

export default UtilsIcon;
